import { useLayoutEffect, useState } from 'react';
import DetectorInstance from '../utils/DetectMostVisibleElement';

const useDetectPercentageViewport = (id: string): boolean => {
  const [current, setCurrent] = useState(false);
  useLayoutEffect(() => {
    DetectorInstance.register(id, setCurrent);
    return () => {
      DetectorInstance.unregister(id);
    };
  }, []);
  return current;
};

export default useDetectPercentageViewport;
